import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button, { ButtonProps } from "./Button";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

export type ButtonIconProps = Omit<ButtonProps, "children"> &
  (
    | {
        children: IconProp;
        icon?: never;
      }
    | {
        icon: IconProp;
        children?: never;
      }
  );

export const ButtonIcon = (props: ButtonIconProps) => {
  const { children, icon, ...rest } = props;
  const buttonIcon = icon || children;
  return (
    <Button {...rest}>
      <FontAwesomeIcon icon={buttonIcon} />
    </Button>
  );
};
